import { __assign } from "tslib";
import formatDistance from 'date-fns/formatDistance';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { UserRole, heapTrackEvent } from '@marvelapp/core';
import * as actionCreators from '../actionCreators';
import Sidebar from '../components/Sidebar';
import { HANDOFF_OPENED } from '../constants/hubspotEventIds';
import { EDIT_PROJECT, USER_FLOWS } from '../constants/utms';
import onlyIf from '../hocs/onlyIf';
import { getInitialZoom, hasHandoffData, isInHandoffMode, } from '../selectors/handoff';
import { getDateModified, getOwnderId, getOwnerUsername, getProjectName, getProjectUrl, getScreenUrl, getUserFlowsUrl, } from '../selectors/project';
import { getCurrentScreen } from '../selectors/screen';
import * as userSelectors from '../selectors/user';
import { getProjectsByOwnerUrl, returnUtm } from '../utils/url';
function mapStateToProps(state) {
    var isDownloadedProject = state.project.isDownloaded;
    var isUserPartOfThisCompany = userSelectors.isUserPartOfThisCompany(state);
    var userRole = userSelectors.getUserRole(state);
    var areCommentsVisible = state.comment.areVisible;
    var isUserReviewer = (userRole === UserRole.ExternalReviewer ||
        userRole === UserRole.InternalReviewer) &&
        isUserPartOfThisCompany;
    var isUserExternalEditor = userRole === UserRole.ExternalEditor && isUserPartOfThisCompany;
    var currentScreen = getCurrentScreen(state);
    var screenUrl = getScreenUrl(state);
    if (screenUrl) {
        screenUrl = returnUtm(screenUrl, EDIT_PROJECT.campaign, EDIT_PROJECT.source, EDIT_PROJECT.medium, EDIT_PROJECT.term, EDIT_PROJECT.content);
    }
    var projectOwner = getOwnerUsername(state);
    var projectOwnerId = getOwnderId(state);
    var projectsByOwnerUrl = getProjectsByOwnerUrl(projectOwnerId, projectOwner);
    var projectModified = formatDistance(getDateModified(state), new Date());
    var projectUrl = returnUtm(getProjectUrl(state), EDIT_PROJECT.campaign, EDIT_PROJECT.source, EDIT_PROJECT.medium, EDIT_PROJECT.term, EDIT_PROJECT.content);
    var userFlowsUrl = returnUtm(getUserFlowsUrl(state), USER_FLOWS.campaign, USER_FLOWS.source, USER_FLOWS.medium, USER_FLOWS.term, USER_FLOWS.content);
    var showScanQR = true;
    if (isDownloadedProject) {
        projectOwner = null;
        projectModified = null;
        projectUrl = null;
        screenUrl = null;
        userFlowsUrl = null;
        showScanQR = false;
    }
    else if (isUserExternalEditor) {
        // TODO: in order to determine the correct visibility of screenUrl and projectUrl
        // we should check if the user has permission to view/edit the current project,
        // but it's not possible due to API limitations.
        // TODO: this is currently hidden, because filtering projects by username
        // is broken for external editors.
        // (https://marvelapp.atlassian.net/browse/BUGS-256)
        projectsByOwnerUrl = null;
    }
    else if (isUserReviewer) {
        screenUrl = null;
        projectUrl = null;
        projectsByOwnerUrl = null;
    }
    else if (!isUserPartOfThisCompany) {
        projectUrl = null;
        projectsByOwnerUrl = null;
        screenUrl = null;
    }
    return {
        areCommentsVisible: areCommentsVisible,
        screenName: currentScreen.name,
        screenNumber: currentScreen.order,
        commentCount: state.comment.count,
        screenCount: state.screen.screenSequence.length,
        isCommentingEnabled: state.project.config.isCommentingEnabled,
        isNavigationEnabled: state.project.config.isNavigationEnabled,
        isDownloadedProject: state.project.isDownloaded,
        isHandoffOpen: isInHandoffMode(state),
        screenHasHandoffData: hasHandoffData(state),
        initialHandoffZoom: getInitialZoom(state),
        projectOwner: projectOwner,
        projectsByOwnerUrl: projectsByOwnerUrl,
        projectModified: projectModified,
        projectName: getProjectName(state),
        projectUrl: projectUrl,
        screenUrl: screenUrl,
        showScanQR: showScanQR,
        userFlowsUrl: userFlowsUrl,
    };
}
function mergeProps(stateProps, _a, ownProps) {
    var dispatch = _a.dispatch;
    var props = {
        onShowPrevious: function () {
            dispatch(actionCreators.showPrevious());
        },
        onShowNext: function () {
            dispatch(actionCreators.showNext());
        },
        onShowHome: function () {
            dispatch(actionCreators.showHome());
        },
        onShowGrid: function () {
            dispatch(actionCreators.showGrid());
        },
        onShowHandoff: function () {
            heapTrackEvent('Opened Handoff');
            if (window._hsq) {
                window._hsq.push([
                    'trackEvent',
                    {
                        id: HANDOFF_OPENED,
                    },
                ]);
            }
            if (stateProps.areCommentsVisible) {
                dispatch(actionCreators.hideComments());
            }
            dispatch(actionCreators.showHandoff());
        },
        onHideHandoff: function () {
            dispatch(actionCreators.hideHandoff());
        },
    };
    return __assign(__assign(__assign({}, ownProps), stateProps), props);
}
var IsNavigationEnabled = function (props) { return props.isNavigationEnabled; };
export default compose(connect(mapStateToProps, null, mergeProps), onlyIf(IsNavigationEnabled))(Sidebar);
